import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { HomeLocationState } from 'src/states';

const methods = ['GET', 'POST', 'PUT', 'DELETE'];

export const requestHeaderInterceptorFn: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  if (methods.includes(request.method) && store.selectSnapshot(HomeLocationState.loaded)) {
    const loggedInLocationId = store.selectSnapshot(HomeLocationState.locationId);

    const modifiedReq = request.clone({
      setHeaders: {
        'Logged-In-Location-Id': '' + loggedInLocationId
      }
    });

    return next(modifiedReq);
  }

  return next(request);
};
